// extracted by mini-css-extract-plugin
export default {"serviceLink":"ServiceCard_serviceLink__FASI-","card":"ServiceCard_card__B9wSA","cardContent":"ServiceCard_cardContent__1Qv49","cardTitle":"ServiceCard_cardTitle__qaDiD"};